import { FinancialOutlookReview } from '../components/FinancialOutlookReview';

export default function OutlookReviewsPage({ role }) {
  if (role !== 'advisor' && role !== 'analyst') {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <h2 className="text-2xl font-semibold mb-2">Access Restricted</h2>
          <p className="text-muted-foreground">
            This feature is only available for Advisors and Analysts
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold">Financial Outlook Reviews</h1>
          <p className="text-muted-foreground mt-1">
            Review and analyze client financial outlooks
          </p>
        </div>
      </div>
      <FinancialOutlookReview userRole={role} />
    </div>
  );
}
